module.exports = __webpack_public_path__ + "img/beigedown-white.1cf7802f.png";